"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentButtonContainer = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
require("./payment-button-container.scss");
const PaymentButtonContainer = (props) => {
    const { className, children } = props;
    const classNames = (0, classnames_1.default)('payment-button-container', className !== null && className !== void 0 ? className : '');
    return (react_1.default.createElement("div", { className: classNames }, children));
};
exports.PaymentButtonContainer = PaymentButtonContainer;
//# sourceMappingURL=PaymentButtonContainer.js.map